import React from "react";
import { Button, Col, Row, Table, Typography } from "antd";
import * as S from "./styles";
import { getColumns } from "./helper";
import { useQuery } from "react-query";
import { fetchInventoryTransfers } from "../../../api/transfer";
import { SearchInput } from "@secondcloset/web-components";
import useUrlState from "hooks/application/useUrlState";
import { useHistory } from "react-router";
import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";
import { Flex } from "css/styles";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export const InventoryTransferIndexPage = () => {
  const history = useHistory();
  const { data: org } = useOrganizationContext();
  const [search, setSearch] = useUrlState({ name: "q", initialValue: "" });
  const [page, setPage] = useUrlState({ name: "page", initialValue: DEFAULT_PAGE });
  const [pageSize, setPageSize] = useUrlState({ name: "pageSize", initialValue: DEFAULT_PAGE_SIZE });
  const { data: transfers, ...transfersQuery } = useQuery(
    ["transfers", search, page, pageSize, org?.id],
    () =>
      fetchInventoryTransfers({
        q: search.trim() || undefined,
        page: page,
        per_page: pageSize,
        organization_id: org?.id,
      }),
    { enabled: !!org?.id }
  );

  const renderHeaderSection = () => {
    return (
      <Flex dir="row" justify="space-between">
        <Typography.Title level={4}>Inventory Transfer</Typography.Title>
        <Button onClick={() => history.push(`/organizations/${org?.id}/transfers/create`)}>Create Transfer</Button>
      </Flex>
    );
  };

  return (
    <div className="page-container" id="inventory-transfer-index-page">
      <S.PageHeader direction="vertical">{renderHeaderSection()}</S.PageHeader>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <SearchInput
            placeholder="Search for Transfers"
            defaultValue={search}
            onSearch={setSearch}
            onClear={() => setSearch("")}
          />
        </Col>
        <Col span={24}>
          <Table
            loading={transfersQuery.isLoading}
            dataSource={transfers?.data || []}
            columns={getColumns(org?.id || "")}
            pagination={{
              size: "default",
              pageSize,
              total: transfers?.meta.total_entries ?? 0,
              current: transfers?.meta.current_page ?? page,
              showLessItems: true,
              showSizeChanger: true,
              showTotal: (total, [min, max]) => `Showing ${min}-${max} of ${total}`,
              onChange: (page, pageSize) => {
                setPage(page);
                setPageSize(pageSize);
              },
            }}
          />
        </Col>
      </Row>
    </div>
  );
};
